interface EventOptions {
  once?: boolean;
}

interface EventConfig {
  callback: Function;
  options: EventOptions;
}
class DispatcherEvent {
  public name: string;  
  public callbacks: EventConfig[];

  constructor(name: string) {
    this.name = name;
    this.callbacks = [];
  }

  registerCallback(callback: Function, options: EventOptions) {
    this.callbacks.push({callback, options});
  }

  unregisterCallback(callback: Function) {
    this.callbacks = this.callbacks.filter(config => config.callback !== callback);
  }

  fire(data: any) {
    this.callbacks.forEach(config => {
      console.log("Firing event", this.name);
      config.callback(data);
      if (config.options.once) {
        this.unregisterCallback(config.callback);
      }
    });
  }
}

export default class EventDispatcher {
  private events: Record<string, DispatcherEvent>;

  private static instance: EventDispatcher;
  static init() {
    if(!this.instance){
      this.instance = new EventDispatcher();
    }
  }
  
  private constructor() {
    this.events = {};   
  }
  
  static dispatch(event: string, data: any = null) {
    this.assertEventExists(event);
    this.instance.events[event].fire(data);
  }

  static registerEvent(eventName: string) {
    if (this.instance.events[eventName]) {
      console.info(`Event ${eventName} already exists`);
    } else {
      this.instance.events[eventName] = new DispatcherEvent(eventName);
    }
  }

  static on(eventName: string, callback: Function, options: EventOptions = {}) {
    this.assertEventExists(eventName);
    this.instance.events[eventName].registerCallback(callback, options);

  }

  static off(eventName: string, callback?: Function) {
    let event = this.instance.events[eventName];
    if(callback === undefined) {
      delete this.instance.events[eventName];
    } else if (event) {
      event.unregisterCallback(callback);
    }
  }

  private static assertEventExists(eventName: string) {
    if (!this.instance.events[eventName]) {
      throw new Error(`Event ${eventName} does not exist`);
    }
  }
}